var AboutView = require("./AboutView");
var Controller = require("common/Controller");
var Utils = require("common/Utils");

/**
 * @class
 * @param {Logger} logger
 * @param {AboutView} aboutView
 * @extends {Controller}
 */
function AboutController(logger, aboutView) {
    Controller.call(this);
    var self = this;

    /**
     * Retrieve the latest log content include it in the about view
     * and display the about view
     */
    this.showAboutView = function() {
        aboutView.setLogContent(logger.getLog());
        self.showView(aboutView);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [aboutView];
    };

    function setVersionLabel(event, serverConfig) {
        if (serverConfig) {
            aboutView.setVersionLabel("");
        }
    }

    $(document).on("connectionsuccessful", setVersionLabel);
    $(document).on("staterestored", setVersionLabel);

    /**
     * @override
     * @inheritDoc
     */
    this.getId = function() {
        return "AboutController";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.setState = function(state) {
        aboutView.setLogContent(logger.getLog());
        self.showView(aboutView);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getState = function() {
        // Need to return something so that we are asked to restore the state on reload
        return {};
    };
}

Utils.inherits(AboutController, Controller);

module.exports = AboutController;